import React from "react";
import { Form, Input } from "antd";
import { NumericFormat } from "react-number-format";
import { allowDecimalwithMaxLimit } from "../services/common.service";

const FloatNumberInput = ({
  name,
  label,
  maxLimit,
  allowNegative = false,
  thousandsSeparator = true,
  thousandsGroupStyle = "lakh",
  prefix,
  suffix,
  size = "large",
  onChange,
  allowLeadingZeros = false,
  disabled,
  minLimit,
}) => {
  const handleValueChange = (values) => {
    if (typeof values.value === "string") {
      const newValue = Number(values.value.replace(/[^0-9.]/g, ""));
      if (newValue <= maxLimit) {
        onChange(newValue);
      }
    }
  };
  const allowOnlyNumberswithMinLimit = (value) => {
    if (typeof value === "string") {
      const newValue = Number(value.replace(/[^0-9.]/g, ""));
      if(newValue < minLimit){
        onChange(minLimit);
      }
    }
  }
  return (
    <Form.Item name={name} label={label}>
      <NumericFormat
        maxLength={4}
        max={maxLimit}
        allowNegative={allowNegative}
        customInput={Input}
        thousandSeparator={thousandsSeparator}
        thousandsGroupStyle={thousandsGroupStyle}
        onValueChange={handleValueChange}
        addonBefore={prefix}
        suffix={suffix}
        size={size}
        disabled={disabled}
        allowLeadingZeros={allowLeadingZeros}
        onBlur={(e) => allowOnlyNumberswithMinLimit(e.target.value)}
        onKeyPress={(e) => allowDecimalwithMaxLimit(e, maxLimit)}
      />
    </Form.Item>
  );
};

export default FloatNumberInput;
